<template>
  <div class="sdk-demo-container">
    <div class="page-main">
      <div id="lbs-header" />
      <div class="page-content-container">
        <div class="page-left-wrapper">
          <div
            id="sidebar-wrapper"
            class="sidebar-wrapper"
          >
            <div class="page-title">
              <!-- eslint-disable -->
              <span v-html="categoryName" />
            </div>
            <div class="sidebar-container">
              <Sidebar
                :nav-list="formatedNavList"
                :default-path="$route.path"
              />
            </div>
          </div>
        </div>
        <div class="page-right-wrapper">
            <div class="page-article-container">
            <div class="page-breadcrumb" v-html="breadcrumb">
            </div>
            <!-- eslint-disable -->
            <div class="article-container demo-container">
                <div class="demo-intro" v-if="article.brief_html_content" v-html="article.brief_html_content">
                </div>
                <div class="demo-content">
                    <el-tabs v-model="activeName" @tab-click="onTabChange">
                        <el-tab-pane label="Android" name="android" v-if="article.html_content" :disabled="!article.ios_html_content">
                            <div class="demo-content-left" v-html="article.html_content">

                            </div>
                            <div class="demo-content-right" v-if="article.download_link || article.video_link">
                                <a class="demo-download" v-if="article.download_link" :href="article.download_link" target="_blank">
                                        下载源代码
                                </a>
                                <div class="demo-video" v-if="article.video_link">
                                    <img class="video-img" src="../img/Android@2x.png" alt="" @click="onAndroidStop">
                                    <video class="android-video" ref="androidVideo" height="576" width="269" loop muted :src="article.video_link">
                                      您的浏览器不支持 video 标签。
                                    </video>
                                    <div class="video-mask" v-if="!isAndroidPlay" @click="onAndroidPlay">

                                    </div>
                                    <img class="video-play" v-if="!isAndroidPlay" src="../img/btn_paly@2x.png" alt="" @click="onAndroidPlay">
                                </div>
                            </div>
                        </el-tab-pane>
                        <el-tab-pane label="iOS" name="ios" v-if="article.ios_html_content" :disabled="!article.html_content">
                            <div class="demo-content-left" v-html="article.ios_html_content">

                            </div>
                            <div class="demo-content-right" v-if="article.ios_download_link || article.ios_video_link">
                                <a class="demo-download" v-if="article.ios_download_link" :href="article.ios_download_link" target="_blank">
                                        下载源代码
                                </a>
                                <div class="demo-video demo-video-ios" v-if="article.ios_video_link" >
                                    <img class="video-img" src="../img/iOS@2x.png" alt="" @click="onIosStop">
                                    <video class="ios-video" ref="iosVideo" height="577" width="269" muted loop :src="article.ios_video_link">
                                    您的浏览器不支持 video 标签。
                                    </video>
                                    <div class="video-mask ios-mask" v-if="!isIosPlay" @click="onIosPlay">

                                    </div>
                                    <img class="video-play" v-if="!isIosPlay" src="../img/btn_paly@2x.png" alt="" @click="onIosPlay">
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
            <!-- <div
              v-html="html"
              class="article-container custom-html-style"
            /> -->
            <!-- <div class="help-container">
              <h2 class="help-h">
                这篇文章对您解决问题是否有帮助？
              </h2>
              <div class="help-radio-group">
                <div
                  :class="['help-radio-item', 'solved', isHelp === 1 ? 'active' : '']"
                  @click="onHelp(1)"
                >
                  <span v-if="!isSubmitFeedback">已解决</span>
                  <span v-if="isSubmitFeedback">提交成功，感谢您的反馈！</span>
                </div>
                <div
                  v-if="!isSubmitFeedback"
                  :class="['help-radio-item', 'unsolved', isHelp === 0 ? 'active' : '']"
                  @click="onHelp(0)"
                >
                未解决
                </div>
              </div>
              <div class="help-feedback" v-if="!isHelp">
                <h2 class="help-h feedback-h">
                    请选择您遇到的问题
                </h2>
                <div class="help-feedback-item help-feedback-checkbox">
                  <el-checkbox-group v-model="feedbackCheckList">
                    <div class="help-feedback-checkbox-item">
                      <el-checkbox label="内容错误/链接错误"></el-checkbox>
                      <el-checkbox label="内容不完整/不详细"></el-checkbox>
                      <el-checkbox label="结构混乱/逻辑不清"></el-checkbox>
                    </div>
                    <div class="help-feedback-checkbox-item">
                      <el-checkbox label="内容更新不及时"></el-checkbox>
                      <el-checkbox label="选中且禁用"></el-checkbox>
                      <el-checkbox label="禁用"></el-checkbox>
                    </div>
                  </el-checkbox-group>
                </div>
                <h2 class="help-h feedback-h">
                    详细问题描述，如您遇见技术问题，请<a href="javascript:;">提交工单</a>
                </h2>
                <div class="help-feedback-item help-feedback-recommend">
                  <el-input
                  type="textarea"
                  placeholder="请描述您使用文档过程中的问题或改进意见"
                  v-model="feedbackRecommend"
                  maxlength="500"
                  show-word-limit
                  resize="none"></el-input>
                </div>
                <div class="help-feedback-submit">
                   <el-button type="primary" @click="onSubmitFeedback">主要按钮</el-button>
                </div>
              </div>
            </div> -->
          </div>
          <div id="lbs-footer">Copyright © 1998-{{new Date().getFullYear()}} Tencent All Rights Reserved 腾讯公司版权所有</div>
        </div>
      </div>
    </div>
    <!-- <anchor-nav v-if="isAnchor" :anchorList="anchorList" :offsetTop="anchorTop"></anchor-nav> -->
  </div>
</template>

<script>
import Sidebar from '~/components/doc-sidebar';
import { getSidebarDataApi, getCategoryInfoApi, getDemoIdApi, getSdkDemoContent } from '~/service/sdk-service';
import util from '~/utils/index';
import { errorLogger } from '~/utils/logger';
const TYPE_MAP = {
  DIR: 1,
  DEMO: 3
};
export default {
  layout: 'default',
  middleware: 'handleHost',
  components: {
    Sidebar
  },
  async asyncData({ params, error, navInit, script }) {
    try {
      const pathArr = params.pathMatch.split('/').filter(path => !!path);
      if (!pathArr.length) {
        error({
          statusCode: 404,
          message: '404 Not Found'
        });
        return;
      }
      const [categoryPathName] = pathArr;
      const currentPathName = `/${pathArr.join('/')}`;
      const [sidebarData, categoryInfo, currentCategoryInfo] = await Promise.all([
        getSidebarData(categoryPathName),
        getCategoryInfo(categoryPathName),
        getCategoryInfo(currentPathName),
      ]);
      // eslint-disable-next-line max-len
      const currentId = currentCategoryInfo.category_id;
      const demoId = await getDemoId(currentId);
      const article =  await getSdkDemo(demoId, currentId);
      return {
        pathArr,
        sidebarData,
        categoryName: categoryInfo.name || '',
        categoryPathName,
        currentPathName,
        currentId,
        currentName: currentCategoryInfo.name,
        article,
        navInit,
        script,
      };
    } catch (err) {
      console.error(err);
      errorLogger(err);
    }
  },
  data() {
    return {
      sidebarData: [],
      categoryName: '',
      categoryPathName: '',
      currentPathName: '',
      currentId: '',
      article: '',
      currentName: '',
      activeName: 'android',
      isIosPlay: false,
      isAndroidPlay: false,
      formatedNavList: [],
      pathNameArr: [],
    };
  },
  computed: {
    breadcrumb() {
      return this.pathNameArr.join(' / ');
    },
  },
  watch: {
    '$route.path'() {
      // v-html在nexttick后，宏任务前更新
      setTimeout(this.runScript, 0);
    },

  },
  created() {
    if (this.article.ios_html_content && !this.article.html_content) {
      this.activeName = 'ios';
    }
    this.pathNameArr = [this.categoryName];
    this.setPathNameArr(this.sidebarData);
    this.formatedNavList = this.handelNavList(this.sidebarData, `/sdkDemoCenter/${this.categoryPathName}`);
  },
  async mounted() {
    util.initPageComponents(this.navInit);
    this.showCurrentSidebar();
  },
  methods: {
    handelNavList(navListData, path) {
      return navListData
        .filter(nav => {
          if (nav.type === TYPE_MAP.DIR && nav.sub_categorys &&
              nav.sub_categorys.some(item => item.type === TYPE_MAP.DEMO || item.type === TYPE_MAP.DIR)) {
            return true;
          } else if (nav.type === TYPE_MAP.DEMO) {
            return true;
          }
          return false;
        })
        .map(nav => {
          const pathMap = nav.path_name;
          return {
            title: nav.name,
            path: this.isExternalLink(pathMap) ? pathMap : `${path}/${pathMap}`,
            isGroupTitle: nav.is_subtitle === 1,
            subNavList: this.handelNavList(nav.sub_categorys, `${path}/${pathMap}`)
          };
        });
    },
    setPathNameArr(navListData, recursionNum = 1) {
      if (!navListData || !Array.isArray(navListData)) return;
      for (const nav of navListData) {
        const pathMap = nav.path_name;
        if (pathMap === this.pathArr[recursionNum]) {
          this.pathNameArr.push(nav.name);
          recursionNum += 1;
          this.setPathNameArr(nav.sub_categorys, recursionNum);
          break;
        }
      }
    },
    isExternalLink(link) {
      if (typeof link !== 'string') {
        return false;
      }
      if (link.indexOf('https') === 0 || link.indexOf('http') === 0) {
        return true;
      }
      return false;
    },
    showCurrentSidebar() {
      const $sidebarContent = $('.demo-sidebar-content');
      const $current = $sidebarContent.find('.demo-sidebar-farther.active');
      const liHeight = $current.find('> span').height();
      const top = $current.length > 0 &&
      $current.position &&
      $current.position().top !== undefined  ? $current.position().top : 0;
      $sidebarContent.scrollTop(top - liHeight);
    },
    onTabChange() {
      if (this.activeName === 'android') {
        this.$refs.iosVideo.pause();
        this.isIosPlay = false;
      } else {
        this.$refs.androidVideo.pause();
        this.isAndroidPlay = false;
      }
    },
    onIosPlay() {
      this.$refs.iosVideo.play();
      this.isIosPlay = true;
    },
    onIosStop() {
      this.$refs.iosVideo.pause();
      this.isIosPlay = false;
    },
    onAndroidPlay() {
      this.$refs.androidVideo.play();
      this.isAndroidPlay = true;
    },
    onAndroidStop() {
      this.$refs.androidVideo.pause();
      this.isAndroidPlay = false;
    }
  },
  head() {
    return {
      title: `${this.currentName} | 腾讯位置服务`,
      meta: [
        { hid: 'description', name: 'description', content: '腾讯地图开放平台为各类应用厂商和开发者提供基于腾讯地图的地理位置服务和解决方案；有针对Web应用的JavaScript API, 适合手机端Native APP的各种SDK, WebService接口和各类地图API等。' },
        { hid: 'keywords', name: 'keywords', content: '腾讯地图开放平台，腾讯地图api，qq地图，腾讯地图街景api，地图api，手机定位api，腾讯lbs，qq map api，qq地图api' }
      ],
      script: this.script
    };
  },

};

async function getSidebarData(pathName) {
  try {
    const data = await getSidebarDataApi({
      path_name: pathName,
      level: 5
    });
    return data.categorys;
  } catch (err) {
    console.error(err);
  }
}


async function getCategoryInfo(pathName, categoryId) {
  try {
    const res = await getCategoryInfoApi({
      path_name: pathName
    });
    if (!categoryId) {
      return res[0] || {};
    }
    return (res.filter(item => item.category_id === categoryId))[0] || {};
  } catch (err) {
    console.error(err);
  }
}

async function getDemoId(currentId) {
  try {
    const res = await getDemoIdApi({
      parent_id: currentId
    });
    return res[0] ? res[0].id : '';
  } catch (err) {
    console.error(err);
  }
}

async function getSdkDemo(articleId, parentId) {
  try {
    const res = await getSdkDemoContent({
      parent_id: parentId,
      article_id: articleId
    });
    return res[0] ? res[0] : '';
  } catch (err) {
    console.error(err);
  }
}
</script>

<style lang="less">
@import './index.less';

/* 机器人小助手 */
.main-contact {
  bottom: 365px!important;
  right: 0!important;
}
.main-contact .icon {
  background-image: url(../img/robot.png)!important;
  width: 18px!important;
  height: 18px!important;
  display: inline-block!important;
  vertical-align: top!important;
  margin-right: 0!important;
}
@media (max-height: 600px), (max-width: 1000px) {
  .main-contact .chat-btn {
      background: #fff!important;
      width: 37px!important;
      height: 118px!important;
      font-size: 16px!important;
      /* padding-top: 5px!important; */
      padding: 10px 0 0 0!important;
  }
  .main-contact .chat-btn .txt {
      line-height: 20px!important;
      margin-top: 10px!important;
  }
  .main-contact .icon {
      margin: 0 auto!important;
  }
}
@media (min-height: 600px) and (min-width: 1000px) {
  .main-contact .chat-btn {
      background: #fff!important;
      width: 37px!important;
      height: 118px!important;
  }
}

.main-contact .chat-btn .txt {
  Writing-mode: tb-rl;
  Text-align: left;
  line-height: 50px;
  color: #000;
  display: block!important;
  margin: 10px auto;
}
</style>
